/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Monitoring API
 * Monitoring API for working with device errors
 *
 * The version of the OpenAPI document: 1.20.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    ExtendedIncidentsTypesEnumModel,
    IncidentReasonEnum,
    IncidentState,
    IncidentsTypesEnumModel,
} from './';

/**
 * Datatype for incident
 * @export
 * @interface Incident
 */
export interface Incident {
    /**
     * @type {string}
     * @memberof Incident
     */
    resolving_type?: IncidentResolvingTypeEnum;
    /**
     * @type {string}
     * @memberof Incident
     */
    comment?: string;
    /**
     * @type {Date}
     * @memberof Incident
     */
    created_time: Date;
    /**
     * @type {string}
     * @memberof Incident
     */
    device_id: string;
    /**
     * @type {IncidentsTypesEnumModel | ExtendedIncidentsTypesEnumModel}
     * @memberof Incident
     */
    error_type: IncidentsTypesEnumModel | ExtendedIncidentsTypesEnumModel;
    /**
     * @type {IncidentReasonEnum}
     * @memberof Incident
     */
    reason?: IncidentReasonEnum;
    /**
     * @type {number}
     * @memberof Incident
     */
    id?: number;
    /**
     * @type {number}
     * @memberof Incident
     */
    zone_id?: number;
    /**
     * @type {number}
     * @memberof Incident
     */
    group_id?: number;
    /**
     * @type {string}
     * @memberof Incident
     */
    zone_name?: string;
    /**
     * @type {string}
     * @memberof Incident
     */
    group_name?: string;
    /**
     * @type {string}
     * @memberof Incident
     */
    network_id?: string;
    /**
     * @type {boolean}
     * @memberof Incident
     */
    damaged_status?: boolean;
    /**
     * @type {boolean}
     * @memberof Incident
     */
    activation_status?: boolean;
    /**
     * @type {boolean}
     * @memberof Incident
     */
    is_resolved?: boolean;
    /**
     * @type {boolean}
     * @memberof Incident
     */
    damaging?: boolean;
    /**
     * @type {Date}
     * @memberof Incident
     */
    resolved_time?: Date;
    /**
     * @type {IncidentState}
     * @memberof Incident
     */
    state: IncidentState;
    /**
     * @type {string}
     * @memberof Incident
     */
    user_id?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum IncidentResolvingTypeEnum {
    Auto = 'auto',
    Manual = 'manual'
}

